import React from 'react';
import '../../css/PreviewPDF.css';

const CostSummary: React.FC<{
  totalPrice?: number;
  paxLabel: string;
  paymentLink: string;
}> = ({ totalPrice, paxLabel, paymentLink }) => {
    const handleGoToPaymentPage = () => {
      window.open(`https://rzp.io/rzp/saD0dXX`, '_blank');
    };
  return (
    <div className="cost-summary-section">
      <h3>Total Cost Including Tax</h3>
      <p className="cost-note">
        Note: Package price, payment schedule and cancellation policy are tentative and subject to change.
        Package price, payment schedule and cancellation policy as shown on the Package Review Page prior to the payment will be final.
      </p>
      <div className="price-row">
        <span className="price-amount">
          ₹ {Number(totalPrice || 0).toLocaleString('en-IN')}
        </span>
        <span className="price-subtext">For {paxLabel}</span>
        <a href={paymentLink}>
          <button className="pay-now-button" onClick={() => handleGoToPaymentPage()}>Pay Now</button>
        </a>
      </div>
    </div>
  );
};

export default CostSummary;
